import type { TreeVM, GetTreesRes } from '~/composables/useRequest/requests/data-contracts';


export const useTreesStore = defineStore('treesStore', () => {
  const { tree } = useRequest();
  const treesStore = ref<TreeVM[]>([]);
  const promiseResponse = ref<Promise<GetTreesRes>>();
  const fetched = ref(false);

  let loadGeneration = 0;
  let inFlightGeneration = 0;

  const getTreesStore = async (mode: 'soft' | 'hard' = 'soft') => {
    if (treesStore.value.length && mode === 'soft') {
      return treesStore;
    }

    if (mode === 'hard' || !promiseResponse.value) {
      inFlightGeneration = ++loadGeneration;
      promiseResponse.value = tree.treeControllerGetTrees();
    }

    const requestGeneration = inFlightGeneration;

    try {
      const { payload } = await promiseResponse.value;

      if (requestGeneration === loadGeneration) {
        fetched.value = true;
        treesStore.value = [...payload].sort((a, b) => a.id - b.id);
      }
    } catch {
      if (requestGeneration === loadGeneration) {
        treesStore.value = [];
      }
    }

    if (requestGeneration === loadGeneration) {
      promiseResponse.value = undefined;
    }

    return treesStore;
  };

  return { getTreesStore };
});
